/**
 * Store Constants - Centralized Store Constants
 * 
 * This file contains all store constants to avoid circular dependencies
 * between app.store.ts and individual store files.
 */

// Club Store Constants
export enum CLUB_STORE_CONST {
  CLUB_STORE_CONST_MODULE_NAME = "CLUB_STORE_CONST_MODULE_NAME",

  // <MUTATIONS>
  CLUB_STORE_MUTATIONS_SET_CLUBS = "CLUB_STORE_MUTATIONS_SET_CLUBS",
  CLUB_STORE_MUTATIONS_SET_CLUBS_LOADING = "CLUB_STORE_MUTATIONS_SET_CLUBS_LOADING",
  // </MUTATIONS>

  // <ACTIONS>
  CLUB_STORE_ACTIONS_GET_COMP_ORGS = "CLUB_STORE_ACTIONS_GET_COMP_ORGS"
  // </ACTIONS>
}

// User Message Store Constants
export enum USER_MESSAGE_STORE_CONST {
  USER_MESSAGE_CONST_MODULE_NAME = "USER_MESSAGE_CONST_MODULE_NAME",
  USER_MESSAGE_MUTATIONS_ADD_MESSAGE = "USER_MESSAGE_MUTATIONS_ADD_MESSAGE",
}

// Auth Store Constants
export enum AUTH_STORE_CONST {
  AUTH_CONST_MODULE_NAME = "AUTH_CONST_MODULE_NAME",
  MUTATIONS_LOGGED_IN = "MUTATIONS_LOGGED_IN",
  AUTH_MUTATIONS_TOKEN_RESPONSE = "AUTH_MUTATIONS_TOKEN_RESPONSE",
  AUTH_MUTATIONS_TOKEN_RESPONSE_FAILURE = "AUTH_MUTATIONS_TOKEN_RESPONSE_FAILURE",
  AUTH_MUTATIONS_PROCESSING_REQ = "AUTH_MUTATIONS_PROCESSING_REQ",
}

// Entry Store Constants
export enum ENTRY_STORE_CONST {
  ENTRY_STORE_CONST_MODULE_NAME = "ENTRY_STORE_CONST_MODULE_NAME",
  ENTRY_STORE_MUTATIONS_ENTRYFORM_SET_CLUB = "ENTRY_STORE_MUTATIONS_ENTRYFORM_SET_CLUB",
  ENTRY_STORE_MUTATIONS_ENTRYFORM_SET_COMPETITION = "ENTRY_STORE_MUTATIONS_ENTRYFORM_SET_COMPETITION",
  ENTRY_STORE_MUTATIONS_SET_SELECTED_ATHLETE = "ENTRY_STORE_MUTATIONS_SET_SELECTED_ATHLETE",
  ENTRY_STORE_MUTATIONS_SET_SELECTED_ATHLETE_GENERIC_DATA = "ENTRY_STORE_MUTATIONS_SET_SELECTED_ATHLETE_GENERIC_DATA",
  ENTRY_STORE_MUTATIONS_UPDATE_SELECTED_ATHLETE_PB = "ENTRY_STORE_MUTATIONS_UPDATE_SELECTED_ATHLETE_PB",
  ENTRY_STORE_MUTATIONS_TOGGLE_SECONDARY_CLAIM = "ENTRY_STORE_MUTATIONS_TOGGLE_SECONDARY_CLAIM",
  ENTRY_STORE_MUTATIONS_RESET_SECONDARY_CLAIM = "ENTRY_STORE_MUTATIONS_RESET_SECONDARY_CLAIM",
  ENTRY_STORE_MUTATIONS_SET_SELECTED_ATHLETE_LOADING = "ENTRY_STORE_MUTATIONS_SET_SELECTED_ATHLETE_LOADING",
  ENTRY_STORE_MUTATIONS_SHOW_ADD_ATHLETE = "ENTRY_STORE_MUTATIONS_SHOW_ADD_ATHLETE",
  ENTRY_STORE_MUTATIONS_SET_ATHLETE_FILTER = "ENTRY_STORE_MUTATIONS_SET_ATHLETE_FILTER",
  ENTRY_STORE_MUTATIONS_SET_ATHLETE_MULTI_PB = "ENTRY_STORE_MUTATIONS_SET_ATHLETE_MULTI_PB",
  ENTRY_STORE_MUTATIONS_SET_ATHLETE_MULTI_PB_LOADING = "ENTRY_STORE_MUTATIONS_SET_ATHLETE_MULTI_PB_LOADING",
  ENTRY_STORE_MUTATIONS_ATHLETE_MULTI_PB_MODAL_SHOW = "ENTRY_STORE_MUTATIONS_ATHLETE_MULTI_PB_MODAL_SHOW",
  ENTRY_STORE_MUTATIONS_ATHLETE_TRIGGER_REFRESH = "ENTRY_STORE_MUTATIONS_ATHLETE_TRIGGER_REFRESH",
  ENTRY_STORE_MUTATIONS_AUTO_SELECT = "ENTRY_STORE_MUTATIONS_AUTO_SELECT",
  ENTRY_STORE_MUTATIONS_AUTO_SELECT_COMP_ORG = "ENTRY_STORE_MUTATIONS_AUTO_SELECT_COMP_ORG",
  ENTRY_STORE_MUTATIONS_AUTO_SELECT_COMP = "ENTRY_STORE_MUTATIONS_AUTO_SELECT_COMP",
  ENTRY_STORE_MUTATIONS_SET_COMPETITIONS = "ENTRY_STORE_MUTATIONS_SET_COMPETITIONS",
  ENTRY_STORE_MUTATIONS_SET_COMPETITIONS_LOADING = "ENTRY_STORE_MUTATIONS_SET_COMPETITIONS_LOADING",
  ENTRY_STORE_MUTATIONS_SET_COMP_PUBLIC = "ENTRY_STORE_MUTATIONS_SET_COMP_PUBLIC",
  ENTRY_STORE_MUTATIONS_SET_SEARCHED_ATHLETES = "ENTRY_STORE_MUTATIONS_SET_SEARCHED_ATHLETES",
  ENTRY_STORE_MUTATIONS_SET_ROUTE_ERROR = "ENTRY_STORE_MUTATIONS_SET_ROUTE_ERROR",
  ENTRY_STORE_MUTATIONS_SET_CLUB_COMP_INFO = "ENTRY_STORE_MUTATIONS_SET_CLUB_COMP_INFO",
  ENTRY_STORE_MUTATIONS_SHOW_ATHLETE_GENERIC_ENTITY_PICKER = "ENTRY_STORE_MUTATIONS_SHOW_ATHLETE_GENERIC_ENTITY_PICKER",
  ENTRY_STORE_GETTERS_IS_ATHLETE_SEARCH_FILTER_ON = "ENTRY_STORE_ACTIONS_IS_ATHLETE_SEARCH_FILTER_ON",
  ENTRY_STORE_GETTERS_SELECTED_ATHLETE = "ENTRY_STORE_GETTERS_SELECTED_ATHLETE",
  ENTRY_STORE_GETTERS_IS_ATHLETE_SELECTED = "ENTRY_STORE_GETTERS_IS_ATHLETE_SELECTED",
  ENTRY_STORE_GETTERS_SELECTED_COMP_IS_TEAM = "ENTRY_STORE_GETTERS_SELECTED_COMP_IS_TEAM",
  ENTRY_STORE_GETTERS_SHOW_ADD_ATHLETE = "ENTRY_STORE_GETTERS_SHOW_ADD_ATHLETE",
  ENTRY_STORE_GETTERS_GET_ATHLETE_CLUB_NAME = "ENTRY_STORE_GETTERS_GET_ATHLETE_CLUB_NAME",
  ENTRY_STORE_GETTERS_HAS_BUILDER_PERM_FOR_COMP = "ENTRY_STORE_GETTERS_HAS_BUILDER_PERM_FOR_COMP",
  ENTRY_STORE_ACTIONS_GET_SELECTED_ATHLETE = "ENTRY_STORE_ACTIONS_GET_SELECTED_ATHLETE",
  ENTRY_STORE_ACTIONS_GET_ATHLETE_MULTI_PB = "ENTRY_STORE_ACTIONS_GET_ATHLETE_MULTI_PB",
  ENTRY_STORE_ACTIONS_GET_COMPETITIONS_BY_ID = "ENTRY_STORE_ACTIONS_GET_COMPETITIONS_BY_ID",
  ENTRY_STORE_ACTIONS_GET_CLUB_COMP_INFO = "ENTRY_STORE_ACTIONS_GET_CLUB_COMP_INFO",
  ENTRY_STORE_MUTATIONS_SUBMIT_ATHLETE_GENERIC_ENTITY = "ENTRY_STORE_MUTATIONS_SUBMIT_ATHLETE_GENERIC_ENTITY",
}

// Config Store Constants
export enum CONFIG_STORE_CONST {
  CONFIG_CONST_MODULE_NAME = "CONFIG_CONST_MODULE_NAME",
  CONFIG_MUTATIONS_SET_APP_CONFIG = "CONFIG_MUTATIONS_SET_APP_CONFIG",
  CONFIG_MUTATIONS_SET_APP_CONFIG_META = "CONFIG_MUTATIONS_SET_APP_CONFIG_META",
  CONFIG_MUTATIONS_SET_IL8N_LANGUAGE = "CONFIG_MUTATIONS_SET_IL8N_LANGUAGE",
  CONFIG_MUTATIONS_SET_THEME = "CONFIG_MUTATIONS_SET_THEME",
  CONFIG_MUTATIONS_SET_ROLE = "CONFIG_MUTATIONS_SET_ROLE",
  CONFIG_MUTATIONS_SET_USER_ENTITY = "CONFIG_MUTATIONS_SET_USER_ENTITY",
  CONFIG_MUTATIONS_SET_USER_MESSAGES = "CONFIG_MUTATIONS_SET_USER_MESSAGES",
  CONFIG_MUTATIONS_SET_UI_VERSION = "CONFIG_MUTATIONS_SET_UI_VERSION",
  CONFIG_MUTATIONS_TOGGLE_COMPETITION_ADMIN_EDIT_MODE = "CONFIG_MUTATIONS_TOGGLE_COMPETITION_ADMIN_EDIT_MODE",
  CONFIG_GETTERS_IS_ADMIN = "CONFIG_GETTERS_IS_ADMIN",
  CONFIG_GETTERS_APP_ADMIN = "CONFIG_GETTERS_APP_ADMIN",
  CONFIG_GETTERS_BUILDER_PERMS = "CONFIG_GETTERS_BUILDER_PERMS",
  CONFIG_GETTERS_USER_ENTITIES = "CONFIG_GETTERS_USER_ENTITIES",
  CONFIG_GETTERS_HAS_ANY_ORG_BUILDER_PERM = "CONFIG_GETTERS_HAS_ANY_ORG_BUILDER_PERM",
  CONFIG_GETTERS_HAS_CHEQUES_ACCESS = "CONFIG_GETTERS_HAS_CHEQUES_ACCESS",
  CONFIG_GETTERS_HAS_FINANCE = "CONFIG_GETTERS_HAS_FINANCE",
  CONFIG_GETTERS_HAS_AAI_FINANCE = "CONFIG_GETTERS_HAS_AAI_FINANCE",
  CONFIG_GETTERS_HAS_CREDIT = "CONFIG_GETTERS_HAS_CREDIT",
  CONFIG_GETTERS_REGISTRATION_SYSTEM_AO_CODE = "CONFIG_GETTERS_REGISTRATION_SYSTEM_AO_CODE",
  CONFIG_ACTIONS_GET_APP_CONFIG = "CONFIG_ACTIONS_GET_APP_CONFIG",
  CONFIG_ACTIONS_IMPERSONATE = "CONFIG_ACTIONS_IMPERSONATE",
  CONFIG_ACTIONS_SWITCH_IL8N_LANGUAGE = "CONFIG_ACTIONS_SWITCH_IL8N_LANGUAGE",
  CONFIG_ACTIONS_SELF_SERVICE = "CONFIG_ACTIONS_SELF_SERVICE",
}

// Team Store Constants
export enum TEAM_STORE_CONST {
  TEAM_STORE_CONST_MODULE_NAME = "TEAM_STORE_CONST_MODULE_NAME",
}

// Cart Store Constants
export enum CART_STORE_CONST {
  CART_CONST_MODULE_NAME = "CART_CONST_MODULE_NAME",
}

// Builder Store Constants
export enum BUILDER_STORE_CONST {
  BUILDER_CONST_MODULE_NAME = "BUILDER_CONST_MODULE_NAME",
}

// Athlete Comp Sched Store Constants
export enum ATH_COMP_SCHED_STORE_CONST {
  ATH_COMP_SCHED_CONST_MODULE_NAME = "ATH_COMP_SCHED_CONST_MODULE_NAME",
  ATH_COMP_SCHED_MUTATIONS_SELECTED = "ATH_COMP_SCHED_MUTATIONS_SELECTED",
  ATH_COMP_SCHED_ACTIONS_GET_CART = "ATH_COMP_SCHED_ACTIONS_GET_CART",
}

// Comp Event Teams Store Constants
export enum COMP_EVENT_TEAMS_STORE_CONST {
  COMP_EVENT_TEAMS_CONST_MODULE_NAME = "COMP_EVENT_TEAMS_CONST_MODULE_NAME",
}

// Public Comps Store Constants
export enum PUBLIC_COMPS_STORE_CONST {
  PUBLIC_COMPS_CONST_MODULE_NAME = "PUBLIC_COMPS_CONST_MODULE_NAME",
}

// Permission Store Constants
export enum PERMISSION_STORE_CONST {
  PERMISSION_CONST_MODULE_NAME = "PERMISSION_CONST_MODULE_NAME",
}

// Field Help Store Constants
export enum FIELD_HELP_STORE_CONST {
  CONST_MODULE_NAME = "CONST_MODULE_NAME",
}

// Checkin Store Constants
export enum CHECKIN_STORE_CONST {
  CHECKIN_CONST_MODULE_NAME = "CHECKIN_CONST_MODULE_NAME",
}

// Scoreboard Store Constants
export enum SCOREBOARD_STORE_CONST {
  SCOREBOARD_CONST_MODULE_NAME = "SCOREBOARD_CONST_MODULE_NAME",
}

// Secondary Store Constants
export enum SECONDARY_STORE_CONST {
  SECONDARY_CONST_MODULE_NAME = "SECONDARY_CONST_MODULE_NAME",
}

// Secondary Cust Store Constants
export enum SECONDARY_CUST_STORE_CONST {
  SECONDARY_CUST_CONST_MODULE_NAME = "SECONDARY_CUST_CONST_MODULE_NAME",
}

// Results Store Constants
export enum RESULTS_STORE_CONST {
  RESULTS_CONST_MODULE_NAME = "RESULTS_CONST_MODULE_NAME",
}

// Schedule Comp Public Store Constants
export enum SCHEDULE_COMP_PUBLIC_STORE_CONST {
  SCHEDULE_COMP_PUBLIC_MODULE_NAME = "SCHEDULE_COMP_PUBLIC_MODULE_NAME",
}